import * as React from 'react';
import { TableProps } from 'semantic-ui-react';
import '../css/table.sass';

export default function Table(props: TableProps) {
  const { className, ...other } = props; // eslint-disable-line @typescript-eslint/no-unused-vars
  return (
    <table className="campfire-table" {...other}>
      {props.children}
    </table>
  );
}
